import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=1f9dfa32&scoped=true&"
import script from "./ListaProdutos.vue?vue&type=script&lang=js&"
export * from "./ListaProdutos.vue?vue&type=script&lang=js&"
import style0 from "./ListaProdutos.vue?vue&type=style&index=0&id=1f9dfa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9dfa32",
  null
  
)

export default component.exports